module.exports = __webpack_public_path__ + "img/DSC00313.110f5f44.JPG";